import React from "react";
import { Typography } from "@payping/web-components";
import { useAppTranslation } from "@/utils/useAppTranslation";

export const InformationSection: React.FC = () => {
  const { t } = useAppTranslation();

  return (
    <div className="tw-mb-6 tw-text-sm tw-leading-relaxed">
      <ul className="tw-list-disc tw-space-x-0 tw-space-y-2 tw-px-0 tw-py-0">
        <li className="tw-flex tw-items-start">
          <span className="tw-bg-gray-400 tw-ml-2 tw-mt-2 tw-inline-block tw-h-1 tw-w-1 tw-flex-shrink-0 tw-rounded-full"></span>
          <Typography.Text type="secondary">{t("profile.bank.info1")}</Typography.Text>
        </li>
        <li className="tw-flex tw-items-start">
          <span className="tw-bg-gray-400 tw-ml-2 tw-mt-2 tw-inline-block tw-h-1 tw-w-1 tw-flex-shrink-0 tw-rounded-full"></span>
          <Typography.Text type="secondary">{t("profile.bank.info2")}</Typography.Text>
        </li>
        <li className="tw-flex tw-items-start">
          <span className="tw-bg-gray-400 tw-ml-2 tw-mt-2 tw-inline-block tw-h-1 tw-w-1 tw-flex-shrink-0 tw-rounded-full"></span>
          <Typography.Text type="secondary">{t("profile.bank.info3")}</Typography.Text>
        </li>
        <li className="tw-flex tw-items-start">
          <span className="tw-bg-gray-400 tw-ml-2 tw-mt-2 tw-inline-block tw-h-1 tw-w-1 tw-flex-shrink-0 tw-rounded-full"></span>
          <Typography.Text type="secondary">{t("profile.bank.info4")}</Typography.Text>
        </li>
      </ul>
    </div>
  );
};

